export function button_filedMirgrants(node) {
  if (
    node.componentName == 'button_text_icon' ||
    node.componentName == 'button_text' ||
    node.componentName == 'button_icon'
  ) {
    if (node.data.design.self_transverseMargin?.diannao == 'margin-left: 0; margin-right:auto;') {
      node.data.design.self_transverseMargin.diannao = 'left'
      node.data.design.self_transverseMargin.pingban = 'left'
      node.data.design.self_transverseMargin.shouji = 'left'
    } else if (
      node.data.design.self_transverseMargin?.diannao == 'margin-left: auto; margin-right: auto;'
    ) {
      node.data.design.self_transverseMargin.diannao = 'auto'
      node.data.design.self_transverseMargin.pingban = 'auto'
      node.data.design.self_transverseMargin.shouji = 'auto'
    } else if (
      node.data.design.self_transverseMargin?.diannao == 'margin-right: 0; margin-left:auto;'
    ) {
      node.data.design.self_transverseMargin.diannao = 'right'
      node.data.design.self_transverseMargin.pingban = 'right'
      node.data.design.self_transverseMargin.shouji = 'right'
    }
  }
  return node
}
